export default __webpack_public_path__ + "images/e121b3ccfb7b002da981b48e5e0e38d2.svg";